import React, { Component } from 'react';
import './description.css';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, Modifier } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';


class Description extends Component {

    resultText = React.createRef();

    state = {
        editorState: EditorState.createEmpty(),
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            value: this.resultText.current.innerText
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    onEditorStateChange = (editorState) => {
        this.setState({ editorState });
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);

        if (this.props.initialValues.value) {
            const { editorState } = this.state;

            const blocksFromHtml = htmlToDraft(this.props.initialValues.value);
            const { contentBlocks, entityMap } = blocksFromHtml;
            let contentState = Modifier.replaceWithFragment(
                editorState.getCurrentContent(),
                editorState.getSelection(),
                ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap()
            );
            this.onEditorStateChange(EditorState.push(editorState, contentState, 'insert-fragment'));
        }
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();

        if (this.props.isResultInput) {
            this.resultText.current.innerHTML = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
        }
    }

    render() {
        const { editorState } = this.state;

        return (
            <>
                <AppInputWrapper>
                    <div
                        className={`description-wrapper ${this.props.isResultInput ? 'is-result' : ''}`}
                        ref={this.resultText}
                    >
                        { draftToHtml(convertToRaw(editorState.getCurrentContent())) }
                    </div>
                </AppInputWrapper>

                {
                    !this.props.isResultInput &&
                    <Editor
                        editorState={editorState}
                        wrapperClassName="description-editor-wrapper"
                        editorClassName="description-editor"
                        onEditorStateChange={this.onEditorStateChange}
                        toolbar={{
                            fontFamily: {
                                options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Noto', 'Segoe UI Regular']
                            },
                        }}
                    />
                }
            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Description)